import { render, staticRenderFns } from "./SafeHtml.ts.vue?vue&type=template&id=f7654ad8&"
import script from "./SafeHtml.ts.vue?vue&type=script&lang=ts&"
export * from "./SafeHtml.ts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports